import { DataService } from "base/services";
import { useAccountStore } from "base/stores";

export const SecurityService = {
  getUserSessions(userId, currentPage, rowsPerPage) {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(
      `/signin/2/${accountId}/${userId}/session?page_number=${currentPage}&page_size=${rowsPerPage}`
    );
  },

  getTwoFactorOptions() {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/user/2/${accountId}/me/twofactor`);
  },

  updateTwoFactorStatus(status) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/user/2/${accountId}/me/twofactor/${status}`);
  },

  getAuthenticatorSecret(type) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/user/2/${accountId}/me/twofactor/${type}`);
  },

  verifyAuthenticatorToken(type, data) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(
      `/user/2/${accountId}/me/twofactor/${type}/verify`,
      {
        data,
        toast: false
      }
    );
  },

  deleteAuthenticator(type) {
    const accountId = useAccountStore.getState()._id;
    return DataService.delete(`/user/2/${accountId}/me/twofactor/${type}`);
  },

  deleteAllSessions(userId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.delete(`/signin/2/${accountId}/${userId}/session`);
  },

  deleteUserSession(userId, sessionId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.delete(
      `/signin/2/${accountId}/${userId}/session/${sessionId}`
    );
  },
  getBotSessions() {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/bot/2/${accountId}/session`);
  },
  deleteAllBotSessions() {
    const accountId = useAccountStore.getState()._id;
    return DataService.delete(`/bot/2/${accountId}/session/batch/delete`);
  },
  deleteBotSession(sessionId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.delete(`/bot/2/${accountId}/session/${sessionId}`);
  }
};
